import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { isUserLoggedIn, clearAuthData } from '../utils/authUtils';
import styles from './CommonHeader.module.scss';
import { userLogoutTrack } from '../utils/mixpanel';

interface CommonHeaderProps {
  showNavigation?: boolean;
  disableNavLinks?: boolean;
}

const CommonHeader: React.FC<CommonHeaderProps> = ({ showNavigation = true, disableNavLinks = false }) => {
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth0();
  
  // Check if user is logged in (either via Auth0 or localStorage)
  const userIsLoggedIn = isAuthenticated || isUserLoggedIn();
  
  // Show navigation if user is logged in, or if explicitly requested
  const shouldShowNav = showNavigation && userIsLoggedIn;

  const resetMixpanel = () => {
    userLogoutTrack();
  }

  return (
    <header className={styles.commonHeader}>
      <Link to="/" className={styles.logoSection}>
        <img 
          src="/synergetics_logo.png" 
          alt="Synergetics Logo" 
          className={styles.logoImage}
        />
      </Link>
      
      {shouldShowNav && (
        <nav className={styles.headerNav}>
          <Link 
            to="/" 
            className={`${styles.navLink} ${location.pathname === '/' ? styles.active : ''}`}
            onClick={disableNavLinks ? (e) => e.preventDefault() : undefined}
            style={disableNavLinks ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : undefined}
          >
            Dashboard
          </Link>
          <Link 
            to="/marketplace" 
            className={`${styles.navLink} ${location.pathname === '/marketplace' ? styles.active : ''}`}
            onClick={disableNavLinks ? (e) => e.preventDefault() : undefined}
            style={disableNavLinks ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : undefined}
          >
            Marketplace
          </Link>
          <Link 
            to="/profile" 
            className={`${styles.navLink} ${location.pathname === '/profile' ? styles.active : ''}`}
            onClick={disableNavLinks ? (e) => e.preventDefault() : undefined}
            style={disableNavLinks ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : undefined}
          >
            Profile
          </Link>
          <button
            onClick={() => {
              // Clear all auth data from localStorage
              clearAuthData();
              resetMixpanel();
              // Logout from Auth0 and redirect to login page
              logout({ logoutParams: { returnTo: `${window.location.origin}/login` } });
            }}
            className={styles.logoutBtn}
          >
            Logout
          </button>
        </nav>
      )}
    </header>
  );
};

export default CommonHeader;